import React from "react";
import { Row, Col, Alert } from "reactstrap";
import { MarkGithubIcon } from "@primer/octicons-react";

import DateText from "~/components/DateText";

type Status =
  | "running"
  | "scheduled"
  | "passed"
  | "failed"
  | "blocked"
  | "canceled"
  | "canceling"
  | "skipped"
  | "not_run"
  | "finished";

export type Build = {
  id: string;
  status: Status;
  buildUrl: string;
  artifactBucket: string;
  appVersion: string;
  commit: string;
  createdAt: string;
  themeId: string;
  requester: {
    name: string;
    email: string;
  };
};

type color = "warning" | "info" | "success" | "danger" | "secondary";

export const statusColor = (status: Status): color => {
  switch (status) {
    case "scheduled":
    case "skipped":
    case "not_run":
      return "info";
    case "passed":
    case "finished":
      return "success";
    case "running":
    case "blocked":
    case "canceling":
      return "warning";
    case "failed":
    case "canceled":
      return "danger";
    default:
      return "secondary";
  }
};

export default function BuildCard(props: { build: Build }) {
  const {
    id,
    themeId,
    buildUrl,
    status,
    appVersion,
    commit,
    createdAt,
    requester,
  } = props.build;

  const githubCommitUrl = `https://github.com/LOKE/app/commit/${commit}`;

  return (
    <Alert color={statusColor(status)}>
      <Row>
        <Col sm="10">
          <a
            href={buildUrl}
            className="alert-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            {appVersion}({id})
          </a>
          {" | "}
          <a
            href={githubCommitUrl}
            className="alert-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <MarkGithubIcon verticalAlign="text-top" /> {commit.slice(0, 7)}
          </a>
        </Col>
        <Col sm="2">
          <div className="float-right">
            <strong>{status.toUpperCase()}</strong>
          </div>
        </Col>
      </Row>
      <Row>
        <Col sm="6">
          <small>
            <DateText date={createdAt} format="datetime" /> by {requester.name}
          </small>
        </Col>
        <Col sm="6">
          <small className="float-right">Theme {themeId}</small>
        </Col>
      </Row>
    </Alert>
  );
}
